import React from 'react';
import './WhyUs.css';

import { Heading } from '../../../components';
import { whyChooseUs } from '../../../constants';



const WhyChooseUs = () => {
  return (
    <section className="whyUs">
      <div className="box-container">
        <div className="content">

          {/* Section Heading */}
          <Heading title={whyChooseUs.heading} subTitle={whyChooseUs.sub} linear />

          <p>{whyChooseUs.content}</p>

          {/* Key Features */}
          <ul className="whyUs-points">
            {whyChooseUs.points.map((point) => (
              <li key={point.id}>
                <h5>{point.title}</h5>
                <div className="icon">{point.icon}</div>
              </li>
            ))}
          </ul>

        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;